import React from "react"
import SingleCampaign from "./singleCampaign"
import AllCampaigns from "./allCampaign"

const ByCampaign = ({ classes, subMenu, subOrgDetails, propertiesOfOrg, allCampaignsByProperties, view, history, handleSelectCampaign, selectedCampaign, setReportData, previewReport }) => {
  if (view == "allCampaign") {
    return <AllCampaigns
      subOrgDetails={subOrgDetails}
      subMenu={subMenu}
      propertiesOfOrg={propertiesOfOrg}
      classes={classes}
      history={history}
      handleSelectCampaign={handleSelectCampaign}
    />
  }
  return (
    <SingleCampaign
      subOrgDetails={subOrgDetails}
      subMenu={subMenu}
      allCampaignsByProperties={allCampaignsByProperties}
      propertiesOfOrg={propertiesOfOrg}
      classes={classes}
      history={history}
      selectedCampaign={selectedCampaign}
      setReportData={setReportData}
      previewReport={previewReport}
    />
  )
}

export default ByCampaign